module.exports = __webpack_public_path__ + "img/fill_main4.db51ca04.png";